// "Shop by price" buckets, shared by the home tiles, the category menu and
// the footer. Bounds are cents and map 1:1 onto the catalog's
// `priceMinCents` / `priceMaxCents` filters.
export interface PriceRange {
  key: 'under5' | 'from5to10' | 'from10to20' | 'over20';
  minCents?: number;
  maxCents?: number;
}

export const PRICE_RANGES: readonly PriceRange[] = [
  { key: 'under5', maxCents: 500 },
  { key: 'from5to10', minCents: 500, maxCents: 1000 },
  { key: 'from10to20', minCents: 1000, maxCents: 2000 },
  { key: 'over20', minCents: 2000 },
];

export function priceRangeLink(range: PriceRange, sort: 'popular' | 'price_asc' = 'popular'): string {
  const params = new URLSearchParams({ sort });
  if (range.minCents !== undefined) params.set('priceMinCents', String(range.minCents));
  if (range.maxCents !== undefined) params.set('priceMaxCents', String(range.maxCents));
  return `/catalog?${params.toString()}`;
}
